import { apiSlice } from "./apiSlice";

export const boundariesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBoundaries: builder.query({
      query: ({admin_level, country, search}) => {
        let url = `/boundaries?admin_level=${admin_level}`
        if(country) { url += "&country="+country }
        if(search) { url += "&search="+search }
        return url
      },
      providesTags: (result = [], error, arg) => [{ type: 'Boundaries', id: JSON.stringify(arg) }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetBoundariesQuery,
  useLazyGetBoundariesQuery
} = boundariesApiSlice
